import Modal from 'developer_components/newModal';
import Swiper from 'swiper';
import {Navigation, Pagination, Thumbs} from 'swiper/modules';

Swiper.use([Navigation, Pagination, Thumbs]);

/**
 * Галерея фото
 * @param {Element} $element Блок с фотографиями
 * @param {Object}  options  Параметры
 */
function PhotogalleryModal(photogallery, options = {}) {
    this.photogallery = photogallery;

    const $element = Modal.createFromHTML(
        `<div class="Photogallery-modal__wrapper">
            <div class="Photogallery-modal__header">
                <div class="Photogallery-modal__title">
                    <h4 class="Photogallery-modal__title-title js-headerTitle"></h4>
                    <span class="Photogallery-modal__title-subtitle js-headerSubtitle"></span>
                </div>
                <button class="Photogallery-modal__close js-modalClose">
                    <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M14.2929 14.2929C14.6834 13.9024 15.3166 13.9024 15.7071 14.2929L22 20.5858L28.2929 14.2929C28.6834 13.9024 29.3166 13.9024 29.7071 14.2929C30.0976 14.6834 30.0976 15.3166 29.7071 15.7071L23.4142 22L29.7071 28.2929C30.0976 28.6834 30.0976 29.3166 29.7071 29.7071C29.3166 30.0976 28.6834 30.0976 28.2929 29.7071L22 23.4142L15.7071 29.7071C15.3166 30.0976 14.6834 30.0976 14.2929 29.7071C13.9024 29.3166 13.9024 28.6834 14.2929 28.2929L20.5858 22L14.2929 15.7071C13.9024 15.3166 13.9024 14.6834 14.2929 14.2929Z" fill="#1E1E1E"/>
                    </svg>
                </button>
            </div>
            <div class="Photogallery-modal__body swiper js-swiperMain">
                <div class="Photogallery-modal__images swiper-wrapper">
                    ${this.photogallery.data.images.map(item => {
                        return (
                            `<div class="Photogallery-modal__image swiper-slide" data-src="${item.original || item.src}"></div>`
                        );
                    }).join('')}
                </div>
                <button class="Photogallery-modal__arrow Photogallery-modal__arrow--prev js-arrowPrev">
                    <svg width="14" height="24" viewBox="0 0 14 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M13.4145 0.585786C14.1955 1.36684 14.1955 2.63317 13.4145 3.41421L4.82867 12L13.4145 20.5858C14.1955 21.3668 14.1955 22.6332 13.4145 23.4142C12.6334 24.1953 11.3671 24.1953 10.586 23.4142L0.586031 13.4142C-0.195018 12.6332 -0.195018 11.3668 0.586031 10.5858L10.586 0.585786C11.3671 -0.195262 12.6334 -0.195262 13.4145 0.585786Z" fill="black"/>
                    </svg>
                </button>
                <button class="Photogallery-modal__arrow Photogallery-modal__arrow--next js-arrowNext">
                    <svg width="14" height="24" viewBox="0 0 14 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M13.4145 0.585786C14.1955 1.36684 14.1955 2.63317 13.4145 3.41421L4.82867 12L13.4145 20.5858C14.1955 21.3668 14.1955 22.6332 13.4145 23.4142C12.6334 24.1953 11.3671 24.1953 10.586 23.4142L0.586031 13.4142C-0.195018 12.6332 -0.195018 11.3668 0.586031 10.5858L10.586 0.585786C11.3671 -0.195262 12.6334 -0.195262 13.4145 0.585786Z" fill="black"/>
                    </svg>
                </button>
            </div>
            <div class="Photogallery-modal__status js-status"></div>
            <div class="Photogallery-modal__nav">
                <div class="swiper js-swiperNav">
                    <div class="Photogallery-modal__images swiper-wrapper">
                        ${this.photogallery.data.images.map(item => {
                            return (
                                `<div class="Photogallery-modal__image swiper-slide" data-src="${item.src}"></div>`
                            );
                        }).join('')}
                    </div>
                </div>
            </div>
        </div>`
    );

    // наследование
    Modal.call(this, $element, options);

    // элементы
    this.$status         = this.$element.querySelector('.js-status');
    this.$headerSubtitle = this.$element.querySelector('.js-headerSubtitle');
    this.$headerTitle    = this.$element.querySelector('.js-headerTitle');

    // свайпер миниатюр
    this.swiperNav = new Swiper(this.$element.querySelector('.js-swiperNav'), {
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        slidesPerView: 'auto',
        spaceBetween: 10,
        observer: true,
        observeParents: true,
        // centeredSlides: true, // крашится
    });

    // основной свайпер
    this.swiperMain = new Swiper(this.$element.querySelector('.js-swiperMain'), {
        loop: true,
        observer: true,
        observeParents: true,
        slidesPerView: 1,
        pagination: {
            el: this.$status,
            type: 'fraction',
        },
        navigation: {
            nextEl: this.$element.querySelector('.js-arrowNext'),
            prevEl: this.$element.querySelector('.js-arrowPrev'),
        },
        thumbs: {
            swiper: this.swiperNav,
        },
        on: {
            slideChange: this._updateNav.bind(this),
            // realIndexChange: this._updateNav.bind(this),
        },
    });

    const $slides = [...this.$element.querySelectorAll('.swiper-slide')];
    const observer = new IntersectionObserver(entries => {
        entries.filter(entry => entry.isIntersecting)
            .forEach(entry => {
                const $slide = entry.target;
                const index = $slides.indexOf($slide);
                const slice = $slides.slice(Math.max(0, index - 3), index).concat($slides.slice(index + 1, index + 3));

                slice.filter($sl => $sl.dataset.src)
                    .forEach($sl => {
                        const $img = document.createElement('img');
                        $img.src = $sl.dataset.src;
                        delete $sl.dataset.src;
                        $sl.append($img);
                    });

                observer.unobserve(entry.target);
            });
    });
    $slides.forEach($element => observer.observe($element))

    this.on('opened', () => {
        this.swiperNav.update();
        this.swiperMain.update();
        this.navigate(this.index);
    });
}

// цепочка прототипов
PhotogalleryModal.prototype = Object.create(Modal.prototype, {
    constructor: {
        value: PhotogalleryModal,
        writable: true,
        enumerable: false,
    },
});

/**
 * Прокрутка до слайда
 * @param {Number} index Порядковый номер слайда (начало с 1)
 */
PhotogalleryModal.prototype.navigate = function(index) {
    this.index = index;

    if (this.isOpened()) {
        this.swiperMain.slideToLoop(this.index);
        this._updateText(this.index);
    }
}

/**
 * Обновление навигации
 */
PhotogalleryModal.prototype._updateNav = function(swiper) {
    this._updateText(swiper.realIndex);
}

PhotogalleryModal.prototype._updateText = function(index) {
    if (this.photogallery.data.images[index]) {
        this.$headerSubtitle.textContent = this.photogallery.data.images[index].subtitle || '';
        this.$headerTitle.textContent = this.photogallery.data.images[index].title || '';
    }
}

export default PhotogalleryModal;
